import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/visa_mastercard.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "page-heading" }, "Tuition Fees", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "page-heading" }, "Card payment", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "You have selected to pay the invoice via a credit or debit card.", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " We accept payment by the following credit/debit cards: Visa, MasterCard. ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, " Lund University will have no access to the data recorded in the payment window and no third party will gain access to your personal or financial details. ", -1)
const _hoisted_8 = ["action"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MirroringUserBanner = _resolveComponent("MirroringUserBanner")!
  const _component_BackToInvoicesButton = _resolveComponent("BackToInvoicesButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (this.isMirroringUser)
      ? (_openBlock(), _createBlock(_component_MirroringUserBanner, {
          key: 0,
          personalId: _ctx.personalId,
          personName: _ctx.personName,
          lucatId: _ctx.lucatId
        }, null, 8, ["personalId", "personName", "lucatId"]))
      : _createCommentVNode("", true),
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _createElementVNode("button", {
      id: "paymentBtn",
      type: "button",
      class: "btn btn-primary mb-3",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.performPayment()))
    }, " Perform payment "),
    _hoisted_6,
    _hoisted_7,
    _createElementVNode("form", {
      action: _ctx.netsUrl,
      method: "post",
      ref: "netsForm"
    }, null, 8, _hoisted_8),
    _createVNode(_component_BackToInvoicesButton)
  ], 64))
}